import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function FAQ({ items, testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white">
      {items.map((item, i) => (
        <div key={i}>
          <button
            type="button"
            data-testid={`${testidPrefix}-question-${i}`}
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 hover:bg-cloud"
          >
            <span className="font-display text-sm font-bold text-navy md:text-base">
              {item.q}
            </span>
            <ChevronDown
              className={`h-5 w-5 shrink-0 text-brand-blue transition-transform duration-300 ${
                open === i ? "rotate-180" : ""
              }`}
            />
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p
                  data-testid={`${testidPrefix}-answer-${i}`}
                  className="px-6 pb-6 text-sm leading-relaxed text-mutedblue"
                >
                  {item.a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
